import { Company } from 'client-experience-toolbox';
export interface DOTCheckResponse {
  crmNumber?: string;
  companyName: string;
  hasFactoring: boolean;
  prefillData?: Record<string, Partial<Company>>;
}

export interface BranchData {
  prefillTrigger?: boolean;
  dotNumber?: string;
}

export enum DOFirebaseEvents {
  FACTORING_APPLICATION_SUBMISSION = 'factoring_app_submission',
}
